import { Remarkable } from 'remarkable'

const md = new Remarkable({
  typographer: true,
})

/*
  only the following works:
  - emphasis, i.e. **bold**
  - italics, i.e. _italics_
  - strikeout, i.e. ~~strike~~
  - ul and ol
*/

md.inline.ruler.disable([
  `backticks`, `ins`, `mark`,
  `sub`, `sup`, `footnote_inline`,
  `footnote_ref`, `autolink`, `htmltag`,
])
md.block.ruler.disable([
  `code`, `fences`, `blockquote`,
  `hr`, `footnote`,
  `heading`, `lheading`, `htmlblock`,
  `table`, `deflist`,
])

// adapted from https://github.com/jonschlinkert/remarkable/blob/58b6945f203ca7a0bb5a0785df90a3a6a8b9e59c/lib/common/utils.js#L112
const HTML_ESCAPE_TEST_RE = /["&()<=>?[\]^_~]/
const HTML_ESCAPE_REPLACE_RE = /["&()<=>?[\]^_~]/g
const HTML_REPLACEMENTS = {
  '"': `&quot;`,
  '&': `&amp;`,
  '(': `&#40;`,
  ')': `&#41;`,
  '<': `&lt;`,
  '=': `&#61;`,
  '>': `&gt;`,
  '?': `&#63;`,
  '[': `&#91;`,
  ']': `&#93;`,
  '^': `&#94;`,
  '_': `&#95;`,
  '{': `&#123;`,
  '}': `&#125;`,
  '~': `&#126;`,
}

const replaceUnsafeChar = (ch) => HTML_REPLACEMENTS[ch]

const escapeHtml = (string) => {
  if (HTML_ESCAPE_TEST_RE.test(string)) {
    return string.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar)
  }
  return string
}

const blacklist = {
  image: (tokens, idx) => {
    const element = tokens[idx]
    return `![${escapeHtml(element.alt)}](${escapeHtml(element.src)})`
  },
}

Object.entries(blacklist).forEach(([rule, func]) => {
  md.renderer.rules[rule] = func
})

export default md